module.exports = __webpack_public_path__ + "img/user.adcb1156.svg";